module.exports = __webpack_public_path__ + "static/media/whatsapp.0e06d4ea.svg";